import { MessageEnvelope } from '../../schema/message';

export const getVisibleMessages = (
  messages: MessageEnvelope[],
  paginationEnd: boolean
): MessageEnvelope[] => {
  if (!messages.length) {
    return [];
  }

  const lowerBoundTimetoken = Number(messages[0].timetoken);

  return messages.filter((message) => {
    const isDeleted = Object.keys(message.actions?.deleted || {}).length > 0;
    if (isDeleted) {
      return false;
    }

    return (
      paginationEnd || Number(message.displayTimetoken) >= lowerBoundTimetoken
    );
  });
};
